<template>
  <div v-if="finishedLoading">
      <div class="row all-tickets" v-if="faturas != null && solicitacao != null">
        <modal v-if="showModal" class="modal-invited" @close="closeModal()">
            <div slot="header">
                <div class="tit float-left">
                    <h2 style="padding-right:50px;"><i class="icon icon-airplane xl"></i> Enviar comprovante de pagamento</h2>
                </div>
            </div>
            <div slot="body" style="overflow-x: auto;">
                <!-- documento enviado com sucesso -->
                <div v-if="submitted" class="success d-flex flex-column justify-content-center align-items-center">
                    <i class="icon icon-success xll"></i>
                    <h3>Documento enviado com sucesso!</h3>
                </div>
                <!-- ***************************** -->
                <div v-else>
                    <files-input :files="files" :accept="acceptedFormats"
                        :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
                    <br />
                    <div class="float-md-right">
                        <button class="btn btn-primary" style="color: #fff !important;"  @click="submit()">Enviar Documentos</button>            
                    </div>
                </div>
                <br/> 
            </div>
        </modal>   
        <div class="col-12">
            <div class="row tit_page">
                <div class="col-12">
                        <div class="float-left">
                            <h1>
                                Meus empréstimos
                                <strong>
                                    {{Document}}
                                </strong> 
                                <span>
                                    id#{{ajustIdOportunidade(id,5)}}
                                </span>
                            </h1>
                        </div>

                        <div class="options float-right">
                            <!-- <a href="#" title="">
                                <i class="printer">
                                &nbsp;
                                </i>
                            </a>
                            <a href="#" title="">
                                <i class="pdf">
                                    &nbsp;
                                </i>
                            </a> -->
                            <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                                <i class="back">
                                    &nbsp;
                                </i> 
                                <span>
                                    Voltar
                                </span>
                            </a>
                        </div>

                        <div class="clearfix"></div>
                        <hr class="divider">
                    </div>
            </div>

            <section>
                <div class="row">
                    <div class="col-12">
                        <h3>
                            <i class="fas fa-barcode"></i>
                            Boletos
                        </h3>
                        <!-- TABELA - TODOS O BOLETOS -->
                        <div class="box-td">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col" width="50" class="align-middle text-center">
                                                Parcela
                                            </th>
                                            <th scope="col" class="align-middle text-center">
                                                Valor
                                            </th>
                                            <th scope="col" width="120" class="align-middle text-center">
                                                Vencimento
                                            </th>
                                            <th scope="col" width="130" class="align-middle text-center" style="display: none;">
                                                Data de Pagamento
                                            </th>
                                             <th scope="col" width="50" class="align-middle text-center">
                                                Boleto
                                            </th>
                                            <th scope="col" width="160" class="align-middle text-center">
                                                Status
                                            </th>
                                           
                                            <th scope="col" class="align-middle text-center">

                                            </th>
                                            <th scope="col"  class="align-middle text-center">

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(fatura, index) in faturas" :key="index" :class="verifyCanceled(fatura.StatusBoleto)">
                                            <td class="align-middle text-center">
                                               {{fatura.IndiceFatura + 1}}
                                            </td>
                                            <td v-if="fatura.HistoricoBoletos" class="align-middle text-center">
                                               {{fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].total}}
                                            </td>
                                            <td v-else class="align-middle text-center">
                                               {{fatura.Boleto.total}}
                                            </td>
                                            <td class="align-middle text-center">
                                                {{formatDate(fatura.Boleto.due_date)}}
                                            </td>
                                            <td class="align-middle text-center" style="display: none;">
                                                09/09/2017
                                            </td>
                                            <td class="align-middle text-center">
                                              	<a v-if="fatura.HistoricoBoletos" :href="fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].secure_url" target="_blank">
													<i class="fas fa-barcode"></i>
												</a>
												<a v-else :href="fatura.Boleto.secure_url" target="_blank">
													<i class="fas fa-barcode"></i>
												</a>
                                            </td>
                                            <td class="status align-middle" :class="getFaturaStatusClass(fatura)">
                                                <span class="sts md"></span>
                                                <span>
                                                    {{getFaturaStatusText(fatura)}}
                                                </span>
                                            </td>   
                                            
                                            <td class="align-middle text-center">
                                                <a class="td-link" id="show-modal" @click="exibeModal(fatura._id, 'Boleto.arquivoComprovantePagamento')">
                                                    <i class="icon icon-send-file sm">
                                                        &nbsp;
                                                    </i>
                                                    Enviar comprovante
                                                </a>
                                            </td>
                                            <td class="align-middle text-center" v-if="fatura.Boleto.arquivoComprovantePagamento && fatura.Boleto.arquivoComprovantePagamento.length > 0">
                                                <a :href="getComprovanteUrl(fatura.Boleto.arquivoComprovantePagamento)" class="td-link" target="_blank">
                                                    <i class="icon icon-eye-2 md">
                                                        &nbsp;
                                                    </i>
                                                    Visualizar comprovante
                                                </a>
                                            </td>
                                            <td class="align-middle text-center" v-else>
                                                -
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- ::::::::::::: -->
                    </div>
                </div>
            </section>
        </div>
    </div>
  </div>
</template>

<!-- PAGE CUSTOM STYLE -->
<style lang="scss" scoped>
  @import "../assets/styles/iouu/mixins";
  @import "../assets/styles/iouu/list-documents";

    @include xs {
        .btn-exit{
            position: absolute;
            top: 2px!important;
            right: 2px!important;
        }
        .btn {
            width: 100%;
        }
    }

  .float-right {
      &{
          text-align: right;
      }
  }

  .table {

      th {

          &:nth-child(2) {
              // MEDIA max: 767px
              @include brkp-01(1130px) {
                  width: 160px !important;
                  display: table-cell !important;
              }
          }

          &:nth-child(5) {
              // MEDIA max: 1230px
              @include brkp-01(1230px) {
                  width: 60px;
              }
          }

          &:nth-child(6) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  display: none;
              }
          }

          &:nth-child(7),
          &:nth-child(8) {
              // MEDIA max: 1130px
              @include brkp-01(1130px) {
                  width: 40px;
              }
          }
      }

      tr {
          &.cld {
              &{
                  background-color: #F2DEDE
              }

              td {
                  &:nth-child(5) {
                    text-transform: uppercase;

                    span {
                        color: red;
                        font-weight: 700;
                    }
                }
              }
          }
      }

      td {

          &:nth-child(2) {
              @include brkp-01(767px) {
                  display: table-cell !important;
              }
          }

          &:nth-child(5) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  text-align: center;
              }

              // MEDIA max: 1230px
              @include brkp-01(1230px) {
                  span {
                      &:last-child {
                          display: none;
                      }
                  }
              }
          }

          &:nth-child(6) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  display: none;
              }
          }

          &:nth-child(7),
          &:nth-child(8) {
              // MEDIA max: 1130px
              @include brkp-01(1130px) {
                  a {
                      &{
                         font-size: 0;
                       }

                      i {
                          font-size: calcRem(25);
                      }
                  }
              }
          }

          i {
              font-size: calcRem(25);
          }

          &.status {
              span {
                  &{
                      display: inline-block;
                      vertical-align: middle;
                      font-size: calcRem(14);
                      padding: 0;
                  }
              }
          }
      }
  }

  .tit_page {

        .float-left {
            h1 {
                @include sm {
                    &{
                        font-size: calcRem(20);
                    }

                    span {
                        font-size: 1rem;
                    }

                    strong {
                        font-size: 1rem;
                    }
                }

                @include xs {
                    & {
                        font-size: calcRem(18);
                    }

                    span {
                        font-size: calcRem(14);
                    }

                    strong {
                        display: none;
                    }
                }

                // MEDIA max: 360px
                @include brkp-01(360px) {
					&{
						font-size: calcRem(15);
					}

					span {
						font-size: calcRem(12);
					}
				}
            }
        }

        .options {
            @include brkp-01(1000px) {
                width: 100%;
                display: inline-block;
                text-align: left;
                padding-top: 1rem;
            }

            @include sm {
                display: none;
            }

            @include xs {
                display: none;
            }
        }
  }

  .box-td {
        &{
            border: none !important;
            padding: 0 !important;
        }
    }
</style>
<!-- :::::::: -->

<script>
    import ApiClient from '../utils/api-client'
    import * as mutationTypes from '@/store/mutation-types.js'
    import Masker from '@/utils/masker'
    import Modal from '@/components/Modal'
    import FilesInput from '@/components/FilesInput'

    import FaturaTomador from '../services/api/faturaTomador';

    export default {
        components: { Modal, FilesInput },    
        data() {
            return {
               finishedLoading: false,
               faturas: null,
               solicitacao: null,
               solicitacaoId: this.$route.query.id,
               showModal: false,
               submitted: false,
               files: [null],
               idBoleto: "",
               /* eslint-disable */  
               uploadEndpoint: process.env.API_NODE+'/files',
               acceptedFormats: 'application/pdf, image/jpeg, image/png', 
            }
        },
        computed: {
            id: function() {return this.ajustIdOportunidade(this.solicitacao.IdOportunidade)},
            Document: function() {return this.formatDocument(this.solicitacao.Documento)},
            receivedFiles() {
                return this.files.filter(file => {
                    return file != null && file != undefined
                });
            }
        },
        methods: {
            ajustIdOportunidade(id, qtd) {
				var s = String(id);
				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}
				return s;
            },
            formatDocument(doc) {
				return Masker.maskCnpj(doc);
			},
            formatDate(date) {
				let dateArray = date.split('-')
				let day = dateArray[2]
				let month = dateArray[1]
				let year = dateArray[0]

				return day + "/" + month + "/" + year;
			},
			getFaturaStatusClass(boleto) {
				let cls;
				let stringDate = boleto.Boleto.due_date;
				let spliter    = stringDate.split("-");
				let boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
				let today      = new Date();
				let status     = boleto.StatusBoleto;

                if(status === "" || status === undefined)  {
					// Sem status
					cls = "ds";
				} else if(boletoDate < today && status !== "paid") {
					// Vencido
					cls = "vc";
				} else if(status === "pending") {
					// A vencer
					cls = "av";
				}  else if (status === "paid"){
					// Quitado
					cls = "qt";
				} 

				return cls;
			},
            getFaturaStatusText(boleto) {
                let txt;
                let stringDate = boleto.Boleto.due_date;
				let spliter    = stringDate.split("-");
				let boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
				let today      = new Date();
				let status     = boleto.StatusBoleto;

                if(status === "" || status === undefined || status === "pending")  {
					txt = "A vencer";
				} else if(boletoDate < today && status !== "paid") {
					txt = "Atrasado";
				} else if (status === "paid"){
					txt = "Pago";
				} else if (status === 'canceled') {
                    txt = "Cancelado"
                }

                return txt;
            },
            exibeModal(id, campo) {
                this.files = [null];
                this.submitted = false;                
                this.showModal = true;

                this.idBoleto = id;
                this.campoMongo = campo;

                if(document.getElementsByTagName("main").length > 0 ){
                     document.getElementsByTagName("main")[0].style.zIndex = "50";
                }
            },
            closeModal() {
                this.showModal = false;

                ApiClient.getFaturas(this.solicitacaoId)
                    .then(response => {
                        this.faturas = response;
                    })
            
                if(document.getElementsByTagName("main").length > 0 ){
                    document.getElementsByTagName("main")[0].style.zIndex = "0";
                }
            },
            onFilesChanged(updatedFiles) {
                this.files = updatedFiles
            },
            getComprovanteUrl(obj){
                let url;

                if(obj.length > 0) {
                    url = obj[obj.length - 1].Nome;
                }

                return process.env.HUB_URL+"/file/" + url;
            },
            verifyCanceled(status) {
                if(status === "canceled") {
                    return "cld"
                }
            },
            submit() {
                this.submitted = true;

                ApiClient.postComprovanteFatura(this.idBoleto, this.campoMongo, this.receivedFiles)
                .then(() => { })
            },
            async getFaturaTomador() {

                const {data} = await FaturaTomador.GetFaturasTomador(this.solicitacaoId);

                if (data) {

                    this.faturas = data;
                }  
            },

            taggingGA() {
                this.$ga.page({
                    page: '/emprestimos/boletos',
                    title: 'Todos os Boletos',
                })
            },
        },
        async created() {
            this.$store.commit(mutationTypes.START_LOADING)

   			await this.getFaturaTomador();

            ApiClient.getLoanRequest(this.solicitacaoId)
            .then(response => {
                this.solicitacao = response;
                this.finishedLoading = true
                this.$store.commit(mutationTypes.STOP_LOADING)
            })
            .catch(() =>{
               this.finishedLoading = true
               this.$store.commit(mutationTypes.STOP_LOADING) 
            })

            await this.taggingGA()
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/AllTickets.vue